import type { QueryClient } from 'react-query';

import { QueryKeys } from '@frontend/features/common/types';

export const cartSaleOrderQueryKey = (
  agencyId: string | number,
  userId?: string,
) => [QueryKeys.saleOrder, agencyId, userId] as const;

/** Una sale order activa sólo es reutilizable dentro de la sesión actual. */
export const clearCartSessionCache = (
  queryClient: Pick<QueryClient, 'removeQueries'>,
) => queryClient.removeQueries([QueryKeys.saleOrder]);
